import Vue from 'vue';
/**
 * This handles displaying generic informational and confirmation modals to the user.
 *
 * Expected use:
 *
 * import modalSvc from '@/services/modalSvc.js';
 * ...
 * Confirm modal:
 *   modalSvc.confirm({
 *     title: 'Confirm title',
 *     message: 'confirm body',
 *     confirmButtonText: 'Save change',
 *     cancelButtonText: 'Cancel',
 *   },
 *   () => {
 *     modalSvc.hide();
 *   },
 *   () => {
 *     modalSvc.hide();
 *   });
 * Informational modal:
 *   modalSvc.inform({
 *     title: 'Inform title',
 *     message: 'Inform body',
 *     confirmButtonText: 'Yep',
 *   },
 *   () => {
 *     modalSvc.hide();
 *   });
 * ...
 */
export default {
  confirm: confirm,
  inform: inform,
  onShow: onShow,
  onHide: onHide,
  show: show,
  hide: hide
};
/**
 * The "bus" is used to do the actual event alerting. This is consumed by TheModal
 */
const bus = new Vue();

function confirm(options, onConfirm, onCancel) {
  show({
    type: 'confirm',
    title: options.title,
    message: options.message,
    confirmButtonText: options.confirmButtonText,
    cancelButtonText: options.cancelButtonText,
    onConfirm: onConfirm,
    onCancel: onCancel,
    confirmButtonClass: options.confirmButtonClass
  });
}

function inform(options, onConfirm) {
  show({
    type: 'inform',
    title: options.title,
    message: options.message,
    confirmButtonText: options.confirmButtonText,
    onConfirm: onConfirm,
    confirmButtonClass: options.confirmButtonClass
  });
}

function onShow(fn) {
  bus.$on('modalShow', fn);
}

function onHide(fn) {
  bus.$on('modalHide', fn);
}

function show(options) {
  bus.$emit('modalShow', options);
}

function hide() {
  bus.$emit('modalHide');
}
